<template>
  <Brands :brands="brands" :title="$t('home.design.footer.title')" :height="45" :margin="margin" />
</template>

<script>
import Brands from '@/components/Common/Brands';

export default {
  name: 'TrustedBy',
  components: {
    Brands
  },
  props: {
    margin: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: () => {
    return {
      brands: [
        {
          src: 'https://cdn.vexels.com/img/trusted/logo-1.png',
          alt: 'Xerox',
          scaledWidth: 85,
          scaledHeight: 45
        },
        {
          src: 'https://cdn.vexels.com/img/trusted/logo-2.png',
          alt: 'Fox Sports',
          scaledWidth: 72,
          scaledHeight: 45
        },
        {
          src: 'https://cdn.vexels.com/img/trusted/logo-3.png',
          alt: 'Nike',
          scaledWidth: 70,
          scaledHeight: 45
        },
        {
          src: 'https://cdn.vexels.com/img/trusted/logo-4.png',
          alt: 'Best Buy',
          scaledWidth: 72,
          scaledHeight: 45
        },
        {
          src: 'https://cdn.vexels.com/img/trusted/logo-5.png',
          alt: 'Ebay',
          scaledWidth: 86,
          scaledHeight: 45
        },
        {
          src: 'https://cdn.vexels.com/img/trusted/logo-6.png',
          alt: 'Museum of Natural Sciences',
          scaledWidth: 123,
          scaledHeight: 45
        }
      ]
    };
  }
};
</script>
